export const features = [
  'feat-columbus',
  'feat-netcracker',
  'feat-simulate-stack',
  'feat-login-with-ciam-ping',
  'feat-netcracker-live',
  'feat-remove-wifi-settings-condition',
  'feat-MitID-CIAM',
] as const;
